import * as React from 'react'

function SvgSendInvitation(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 30 30" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.354 20.783a1.5 1.5 0 01.177-2.114l2.5-2.116a1.5 1.5 0 011.937 2.29l-2.5 2.116a1.5 1.5 0 01-2.114-.176z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M27.578 2.458a1.5 1.5 0 01.31 1.608l-8.234 20.227a1.5 1.5 0 01-2.446.499l-1.789-1.777-7.828.482a1.5 1.5 0 01-1.153-2.558l3.435-3.435-5.355-5.273a1.5 1.5 0 01.537-2.477L25.983 2.09a1.5 1.5 0 011.595.367zM11.995 15.383l6.787-6.788a1.5 1.5 0 012.122 2.121L11.36 20.26l2.181-.134a1.5 1.5 0 012.514-.706l1.669 1.657 6.107-15.002-15.52 5.682 3.683 3.627z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.497 24.503a1.5 1.5 0 01-.122 2.117l-1.123 1a1.5 1.5 0 11-1.995-2.24l1.122-1a1.5 1.5 0 012.118.123z"
        fill="currentColor"
      />
    </svg>
  )
}

export default SvgSendInvitation
